// extracted by mini-css-extract-plugin
export default {"selector":"PageSelector_selector__5EHf6"};